import * as API from 'src/helpers/api_helper'
import * as URL from 'src/helpers/url_helper'

//

export const PlanPaymentHistoryMemberApi = (data) =>
    API.get(`${URL.PLAN_PAYMENT_HISTORY_MEMBER}/${data?.club_id}`, data)

export const ClubGrandTotalApi = (ID) => API.get(`${URL.CLUB_GRAND_TOTAL_URL}/${ID}`)
